export default "__VITE_ASSET__BX8oOLKT__"